<template>
  <!-- :class="{'is-eng': isEngLang}" -->
  <div id="app">
    <iot-header :show="!$route.meta.headerHide"></iot-header>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <iot-footer :show="!$route.meta.footerHide"></iot-footer>
    <div class="back-top" @click="backTop()" v-show="showTop">
      <i class="iconfont icon-arrow-up"></i>
    </div>
  </div>
</template>

<script>
import { getCookie } from '@/utils/auth'
import iotHeader from '@/components/Header.vue'
import iotFooter from '@/components/Footer.vue'
export default {
  name: 'App',
  components: {
    iotHeader,
    iotFooter
  },
  mounted () {
    // 检测是否被嵌套
    if (window.top != window.self) {
      let pathname = this.$route.name
      console.log('pathname', pathname)
      if (pathname !== '/404') {
        this.$router.push({
          path: '/404'
        })
      }
    }
    setTimeout(() => {
      let lang = this.$route.query.lang
      // 判断lang是否传值, 如果未传值，则使用localStroage中的值
      if (typeof lang === 'undefined') {
        lang = window.localStorage.hasOwnProperty('iot-lang') ? window.localStorage.getItem('iot-lang') : 'zh'
        // lang = getCookie('iot-lang') ? getCookie('iot-lang') : 'zh'
      }
      this.$i18n.locale = lang
      this.$store.dispatch('setIotLang', lang)
    }, 200)
    this.$nextTick(() => {
      window.addEventListener('scroll', this.scroll)
    })
  },
  computed: {
    // isEngLang () {
    //   return this.lang === 'en'
    // }
  },
  data () {
    return {
      showTop: false
    }
  },
  methods: {
    scroll () {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 100) {
        this.showTop = true
      } else {
        this.showTop = false
      }
    },
    backTop () {
      let ele = document.body.scrollTop !== 0 ? document.body : document.documentElement
      let timer = setInterval(() => {
        if (ele.scrollTop <= 0) {
          clearInterval(timer)
        }
        ele.scrollTop -= 80
      }, 1)
    }
  }
}
</script>

<style>
* {
  box-sizing: border-box;
}
html, body {
  height: 100%;
  color: #666;
  font-size: 14px;
}
body {
  overflow-y: scroll;
}
#app {
  position: relative;
  width: 100%;
  min-height: 100%;
}
/* @media screen and (max-width: 640px) {
  #app {
    padding-bottom: 120px;
  }
} */
.back-top{
  cursor: pointer;
  width: 50px;
  height: 50px;
  border-radius: 4px;
  color: #dddddd;
  background-color: #fff;
  box-shadow:1px 0px 10px rgba(102,102,102,0.1);
  position: fixed;
  bottom: 180px;
  right: 40px;
  text-align: center;
  line-height: 50px;
  transition: all .5s;
}
.back-top:hover{
  color: #569AFF;
}

</style>



// WEBPACK FOOTER //
// src/App.vue